export const SET_CURRENT_VOICE = 'SET_CURRENT_VOICE'
export const SET_PLAYLIST = 'SET_PLAYLIST'
export const SET_PLAYING_STATUS = 'SET_PLAYING_STATUS'
export const TOGGLE_VISIBLE_AUDIO_PLAYER = 'TOGGLE_VISIBLE_AUDIO_PLAYER'